// ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Providers/AuthContext';
import {isLoggedIn} from "../utils/auth";

export const ProtectedRoute = ({ children, requiredPermission }) => {
    const { isAuthenticated, ability, initialized } = useAuth();
    const location = useLocation();

    if (!isLoggedIn()){
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Wait until authentication state is initialized
    if (!initialized) {
        return <div>Loading...</div>;
    }

    // Redirect unauthenticated users to the login page
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Redirect users without the required permission to unauthorized page
    if (requiredPermission && !ability?.can(...requiredPermission.split('.'))) {
        return <Navigate to="/unauthorized" replace />;
    }

    // If authenticated and authorized, render the children
    return children;
};
